import {
  createElement,
  CSSProperties,
  type ReactElement,
  type ReactNode,
} from 'react';
import { AstElementAttributes, BlockIndex } from '../types';

export function createHeadingCopyLinkButton(blockId: BlockIndex): ReactElement {
  return (
    <button
      key={`copy-link-${blockId}`}
      type='button'
      aria-label='Kopioi linkki kappaleeseen'
      onClick={() => {
        const url = new URL(window.location.href);
        url.searchParams.set('chapterId', blockId.toString());
        const text = url.toString();

        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(text).catch((error) => {
            console.error('Failed to copy link to clipboard:', error);
          });
        }
      }}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        width: '24px',
        height: '24px',
        marginLeft: '4px',
        color: 'inherit',
        opacity: 0.6,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = '1';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = '0.6';
      }}
      onFocus={(e) => {
        e.currentTarget.style.opacity = '1';
      }}
      onBlur={(e) => {
        e.currentTarget.style.opacity = '0.6';
      }}
    >
      <svg width='16' height='16' viewBox='0 0 24 24' fill='currentColor'>
        <path d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' />
      </svg>
    </button>
  );
}

export function createHeading(
  tagName: string,
  attributes: AstElementAttributes,
  children: ReactNode[],
  blockId: BlockIndex,
): ReactElement {
  const copyLinkButton = createHeadingCopyLinkButton(blockId);

  return createElement(
    tagName,
    {
      ...attributes,
      'data-block-id': blockId,
      id: (attributes as any).id ?? `b${blockId}`, // eslint-disable-line @typescript-eslint/no-explicit-any
      key: `heading-${blockId}`,
      style: {
        position: 'relative',
        wordBreak: 'break-word',
        ...(typeof attributes.style === 'object' && attributes.style !== null
          ? (attributes.style as CSSProperties)
          : {}),
      },
    },
    [...children, copyLinkButton],
  );
}
